import Vue from 'vue';

export default Vue.component('edit-header', {
  template: require('./template.html'),
  name: 'edit-header',
  props: ['droplet', 'show-edit-bubble'],
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/header/components/_edit-options/index.js